import { render } from "./AddVente.vue?vue&type=template&id=c0472666&scoped=true&ts=true"
import script from "./AddVente.vue?vue&type=script&lang=ts"
export * from "./AddVente.vue?vue&type=script&lang=ts"

import "./AddVente.vue?vue&type=style&index=0&id=c0472666&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0472666"]])

export default __exports__